<template>
  <div class="row mt-4 mb-5">
    <div class="col-12">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              :to="{ name: 'socioTherapyCoachingNewAndActiveList' }"
              :class="{ active: $route.name === 'socioTherapyCoachingNewAndActiveList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Aktiv + Neu
          </router-link>
          <router-link
              :to="{ name: 'socioTherapyCoachingFinishedList' }"
              :class="{ active: $route.name === 'socioTherapyCoachingFinishedList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            In den letzten 60 Tagen abgeschlossen
          </router-link>
          <router-link
              :to="{ name: 'socioTherapyCoachingArchivedList' }"
              :class="{ active: $route.name === 'socioTherapyCoachingArchivedList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Archiv
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>